import React, { useState, useEffect } from "react";
import Cards from './Cards';
import { booksData } from "./data";
import './Styles/Load.scss';
const postsPerPage = 6;
let arrayForHoldingPosts = [];

const Load=()=>{
    const [postsToShow, setPostsToShow] = useState([]);
  const [next, setNext] = useState(6);
  const loopWithSlice = (start, end) => {
    const slicedPosts = booksData.slice(start, end);
    arrayForHoldingPosts = [...arrayForHoldingPosts, ...slicedPosts];
    setPostsToShow(arrayForHoldingPosts);
  };

  
  useEffect(() => {
    loopWithSlice(0, postsPerPage);
  }, []);

  const handleShowMorePosts = () => {
    loopWithSlice(next, next + postsPerPage);
    setNext(next + postsPerPage);
  };
  return(
      <div className="loadebook">
          <Cards postsToRender={postsToShow} />
          <button onClick={handleShowMorePosts}>Load more</button>
      </div>
  )
};
export default Load ;